import { ReactComponent as CloseIcon } from '@assets/icons/close-chip.svg';

const ChipList = ({ chipList = [], removeItemFromFilter }) => {
	return chipList.map((chip, index) => {
		if (
			// chip.name !== 'filterCategory' &&
			chip.value !== 'All' &&
			chip.name !== 'status' &&
			chip.name !== 'isBuyerRequest' &&
			chip.identifier !== 'sort-order' &&
			chip.value
		) {
			return (
				<div className="chip" key={`chip_${index}`}>
					<span>{chip.value}</span>
					<span
						className="chip-close cursor-pointer"
						onClick={(e) => {
							e.stopPropagation();
							removeItemFromFilter(chip);
						}}
					>
						<CloseIcon />
					</span>
				</div>
			);
		}
	});
};

export default ChipList;
